import React, { useEffect, useState } from 'react'
import {
  List,
  Datagrid,
  TextField,
  useTranslate,
  useResourceContext,
  useResourceDefinitions,
  useListController,
  DateField,
  useStore,
  useRemoveFromStore,
  FunctionField,
  NumberField,
} from 'react-admin'

import { useQuery } from 'react-query'
import { Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ListViewActionsButtons } from 'src/components/uiElements/buttons/ListViewActionsButtons'
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'
import { productTypeServices } from 'src/services/reservation/product-type/product_type.service'
import { SplitByCharacterWithPosition } from 'src/helper/splitByCharacter'
import { PostFilterButtonBusinessRule, PostFilterFormBusinessRule } from './BusinessRuleFilter'

export function BusinessRuleList(props) {
  const translate = useTranslate()
  const { setSort, isFetching } = useListController()
  const [isSorting, setIsSorting] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [permissionsStore, setPermissionsStore] = useStore('currentResource', '{}')
  const [permissions, setPermissions] = useState(null)
  const propsResource = useResourceDefinitions()
  const resourceName = useResourceContext()
  const [destinationTypes, setDestinationTypes] = useState([])

  
  const removeStore = useRemoveFromStore('businessRule.listVar')
  const ruleTypes = useQuery('rule-type-all', businessRuleServices.getRuleTypes)
  const productType = useQuery('product-type-all', () => productTypeServices.getByParam({limit: 9999}))

  const getdestinationsType = async() =>{
    await businessRuleServices.getDestinationTypes().then(types=>{
      setDestinationTypes(types)
    })
  }

  const getDestinationTypeById = (id) =>{
    for(let type of destinationTypes){
      if(type.id == id){
        return type.name
      }
    }
  }

  useEffect(() => {
    removeStore()
    getdestinationsType()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setPermissionsStore(JSON.stringify(propsResource[resourceName]))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsResource, resourceName])

  useEffect(() => {
    if (permissionsStore) {
      setPermissions(JSON.parse(permissionsStore))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissionsStore])

  useEffect(() => {
    if (isSorting && isFetching) {
      setIsLoading(true)
    } else if (isLoading && isSorting && !isFetching) {
      setIsLoading(false)
      setIsSorting(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSorting, isFetching])

  const onClickSort = (sort) => {
    setSort(sort)
    setIsSorting(true)
  }

  const hasPermissions = () => {
    return permissions?.hasEdit && permissions?.hasCreate && permissions?.options.delete
  }


  const refactorRefTableDetailInProductType = (options) => {
    try {
      return options?.map((option) => {
        return {
          ...option,
          ref_table_detail: SplitByCharacterWithPosition(option?.ref_table_detail, '_', 0),
        }
      })
    } catch (error) {
      return []
    }
  }
  
  const allFilters = [
    { source: 'is_active', name: 'ra.field.is_active' },
    { source: 'base_to_billing__in', name: 'ra.field.billing_base' },
    { source: 'id', name: 'ra.field.id' },
    { source: 'name__ilike', name: 'ra.field.name' },
    { source: 'priority', name: 'ra.field.priority' },
    { source: 'rule_type_id', name: 'ra.field.rule_type' },
    { source: 'ref_table_detail_ilike_in', name: 'ra.field.product_type' },
    { source: 'destination_type_id__in', name: 'ra.field.destination_type' },
    { source: 'work_unit_token__in', name: 'ra.field.work_unit' },
  ]

  return (
    <Container className='content'>
      <CardCommon title={translate('ra.entity.business-rule')}>
        <List
          {...props}
          component='div'
          actions={
            <ListViewTopToolbar
              hasCreate={permissions?.hasCreate}
              updateRuleView={permissions?.hasEdit}
              listFilters={allFilters}
              FilterButtonComponent={PostFilterButtonBusinessRule}
              FilterFormComponent={PostFilterFormBusinessRule}
            />
          }
          sort={{ order: '-', field: 'id' }}
        >
          <Datagrid setSort={onClickSort} isLoading={isLoading}>
            <TextField source='id' label={translate('ra.field.id')} />
            <TextField source='name' label={translate('ra.field.name')} />
            <FunctionField
              label={translate('ra.field.rule_type')}
              render={(record) => translate(`ra.rule_type.${record?.short_name}`)}
            />
            <TextField
              source='parent_rule'
              label={translate('ra.field.parent_businessRule')}
              sortable={false}
            />
            <TextField source='is_active' label={translate('ra.field.is_active')} sortable={false} />
            <DateField
              source='rule_date_start'
              label={translate('ra.field.start_validity_rule')}
              sortable={false}
            />
            <DateField source='rule_date_end' label={translate('ra.field.end_validity_rule')} sortable={false} />
            <FunctionField
              render = {(record) => {return getDestinationTypeById(record.destination_type_id)}}
              label={translate('ra.field.destination_type')}
              sortable={false}
            />
            <NumberField label={translate('ra.field.priority')} source='priority' />
            <FunctionField
              label={translate('ra.field.product_type')}
              render={(record) =>
                translate(
                  `ra.title.${SplitByCharacterWithPosition(record?.ref_table_detail, '_', 0)?.toLowerCase()}`
                )
              }
            />
            {hasPermissions() && (
              <ListViewActionsButtons
                label={translate('ra.action.actions')}
                fieldsName={['name']}
                genderElement='femenine'
                clone={true}
              />
            )}
          </Datagrid>
        </List>
      </CardCommon>
    </Container>
  )
}
